import { IConfig } from './IConfig';
import { Enviroment, IConfigService } from './IConfigService';

export const ProdSubDomains = [
    'ADMIN'
    // , 'OFFICER', 'LEGAL', 'CARTORIO', 'APP',
    // 'ADMIN2', 'OFFICER2', 'LEGAL2', 'CARTORIO2', 'APP2', 'DECODE'
]

const miscellaneousConfig = {
    gATracking: "UA-128076428-1",
    hotjarId: "1082572",
    hotjarSV: "6",
    gTag: "GTM-TLT2PTG",
    fbAppId: "551236288706917",
    googleAppId: "1049493526687-41s8e31v8a0v88ev8lp9hl4ug0oeqthi.apps.googleusercontent.com",
};

const defaultConfig = {
    baseUrl: "admin",
    version: "app_version_admin"
}
const ConfigService: IConfigService = {
    enviroments: {
        LocalHost: {
            env: 'LocalHost',
            apiUrl: 'https://localhost:44370/api/public',
            apiUrlOut: 'https://localhost:44370/api/public',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            sideMenuColor: '#001e62',
            sideMenuItemColor: '#0a1e8c',
            awsConfig: {
                cognitoUserPoolId: "us-east-1_6Kz2nw2PU",
                cognitoRegion: "us-east-1",
                userPoolWebClientId: "3qt2fuagc2p6onraroeqkljn6j",
                userPoolIdentityPoolId: "us-east-1:5649e3ca-1ed2-43c1-94e9-0c82369c40ef",
                userPoolIdentityId: " us-east-1:5649e3ca-1ed2-43c1-94e9-0c82369c40ef"
            }
        },
        Development: {
            env: 'Development',
            apiUrl: 'https://api-dev-portalconsorcio.pactual.net/api/public',
            apiUrlOut: 'https://api-dev.consortbrasil.com.br',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            sideMenuColor: '#c28c29',
            sideMenuItemColor: '#ebab34',
            awsConfig: {
                cognitoUserPoolId: "us-east-1_6Kz2nw2PU",
                cognitoRegion: "us-east-1",
                userPoolWebClientId: "3qt2fuagc2p6onraroeqkljn6j",
                userPoolIdentityPoolId: "us-east-1:5649e3ca-1ed2-43c1-94e9-0c82369c40ef",
                userPoolIdentityId: "us-east-1:5649e3ca-1ed2-43c1-94e9-0c82369c40ef"
            }
        },
        Staging: {
            env: 'Staging',
            apiUrl: 'https://api-uat-portalconsorcio.pactual.net/api/public',
            apiUrlOut: 'https://api-uat.consortbrasil.com.br',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            sideMenuColor: '#a62d2d',
            sideMenuItemColor: '#cf3838',
            awsConfig: {
                cognitoUserPoolId: "us-east-1_Hj9wzXfPG",
                cognitoRegion: "us-east-1",
                userPoolWebClientId: "undb4na0efr094v4d51t96ut5",
                userPoolIdentityPoolId: "us-east-1:9fa9097d-25ff-4666-9924-8b13a77fd098",
                userPoolIdentityId: "us-east-1:9fa9097d-25ff-4666-9924-8b13a77fd098"
            }
        },
        Production: {
            env: 'Production',
            apiUrl: 'https://api-portalconsorcio.pactual.net/api/public',
            apiUrlOut: 'https://api.consortbrasil.com.br',
            baseUrl: defaultConfig.baseUrl,
            version: defaultConfig.version,
            gRecaptcha: '6LdStg4cAAAAAJfkKxvrVsJzzF4WVP1R8pn_Q39q',
            miscellaneousConfig,
            sideMenuColor: '#fafafa',
            sideMenuItemColor: '#5cbf92',
            awsConfig: {
                cognitoUserPoolId: "sa-east-1_QrzKGW4W6",
                cognitoRegion: "sa-east-1",
                userPoolWebClientId: "ttb22bv1pk810612r5vhfdmgh",
                userPoolIdentityPoolId: "sa-east-1:11c70699-cfc5-4cc3-8e0b-3f0af9264fc7",
                userPoolIdentityId: "sa-east-1:11c70699-cfc5-4cc3-8e0b-3f0af9264fc7"
            }
        }
    },

    getEnv(): Enviroment {
        const subDomain = location.hostname.split('.')[0].toUpperCase();

        if (subDomain.includes("-DEV")) {
            return "Development";
        } else if (subDomain.includes("-UAT")) {
            return "Staging";
        } else if (ProdSubDomains.includes(subDomain)) {
            return "Production";
        } else {
            return "LocalHost";
            // return "Development"; 
        }
    },

    getConfig(): IConfig {
        const env = this.getEnv();
        const enviroment = this.enviroments[env]!;
        return enviroment;
    }
}

export default ConfigService;




// WEBPACK FOOTER //
// ./src/services/config/config.service.ts